module.exports = __webpack_public_path__ + "83086b27db7aeb83ab6c85d27cb2e4d9.svg";